<template>
  <main class="project" id="projects">
    
    <h1 id="pTop">Project details</h1>

    <div class="spinerParent" v-if="loading">
      <img src="../assets/spin.png" class="imgRevert" />
    </div>

    <div id="projContainer" v-else>

      <section class="zeroProj" v-if="(projects.length < 1 && loading == false) && !fetchErr">
        <h2>No project found.</h2>
      </section>

      <fetchError @ready="catchReady($event)" :style="{display:fetchErr?'flex':'none'}" :Exception="fetchErr" />

      <Project v-for="(project, i) in projects" :key="i" :projectData="project" :tools="tools" />
    </div>

  </main>
</template>

<script>
import Request from "../mixins/axiosRequest";
import Project from "../components/Small/Project.vue";
import fetchError from "../components/Small/fetchError.vue";

import queryPalette from "../mixins/themeColor.js";

export default {
  name: "Projects",
  title: "Project filter - Nethanzêl's Showroom",
  
  components: {
    Project,
    fetchError
  },

  data() {
    return {
      projects: [],
      tools: [],
      loading: true,
      fetchErr: null
    };
  },

  methods: {
    async getProjects() {
      let projRef = this.$router.currentRoute.params.query;
      let data = await Request.axiosGet(`/api/project/${projRef}`, this.client);
      if(data.status) {
        this.projects = data.data.reverse();
      } else {
        this.fetchErr = data.data;
      }
      this.loading = false;
      this.meshApply();
    },

    async getSkills() {
      let data = await Request.axiosGet("/api/skills", this.client);
      if(data.status) {
        this.tools = data.data[0].technical;
        this.getProjects();
      } else {
        this.loading = false;
        this.fetchErr = data.data;
        this.meshApply();
      }
    },

    pluralizeProject(num) {
      if (num == 1) {
        return `+${num} project`;
      } else if (num > 1) {
        return `+${num} projects`;
      }
    },
    meshApply() {
      queryPalette.generatePalette().then((Palette) => {
        document.querySelector("#projContainer").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#projContainer").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#projContainer").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
      });
    },

    catchReady(evt) {
      if(evt && this.fetchErr) {
        evt(this.fetchErr.message , this.fetchErr.name);
      }
    },
  },

  mounted() {
    this.loading = true;
    this.getSkills();
  }
};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  #projContainer {
    background-color: #fff;
  }
  h1 {
    color: #fff;
  }
  h1::after {
    border-bottom: 2px solid #fff;
  }
}

@media (prefers-color-scheme: light) {
  #projContainer {
    background-color: #d1d1d1;
  }
  h1 {
    color: #000;
  }
  h1::after {
    border-bottom: 2px solid #000;
  }

  .imgRevert {
    filter: invert(1);
  }

}

.project {
  display: flex;
  flex-direction: column;
  cursor: default;
  max-width: 1366px;
  margin: 0 auto 0 auto;
  padding-top: 60px;
  min-height: 100vh;

}

.zeroProj {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto 0;
}

#projContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: .4s;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  z-index: 5;
  margin: 0 5px;
  color: #000;
  min-height: 50vh;

  padding: 50px 0;
}

h1 {
  letter-spacing: 3px;
  text-align: center;
  width: 100%;
  cursor: default;
  z-index: 10;
  margin-bottom: 45px;
  margin-top: 25px;
  transition: .4s;
}

h1::after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 280px;
  margin-top: 10px;
}

.spinerParent {
  margin: auto 0 auto 0;
}


//====================================================

//====================================================


@media screen and (max-width: 780px) {

  h1 {
    padding-bottom: 10px;
  }
}

@media screen and (max-width: 445px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    top: 0;
    letter-spacing: 3px;
    font-size: 45px;
  }
}

@media screen and (max-width: 415px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    top: 0;
    letter-spacing: 3px;
    font-size: 45px;
  }
}

@media screen and (max-width: 395px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    letter-spacing: 3px;
    font-size: 40px;
  }
}

</style>
